// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const listRecentGamesService = async () => {
  return privateRequest.get(ConfEnv.API_GAMES.LIST_RECENT_GAMES);
};
